import React from "react";
import PropTypes from "prop-types";

const AdminAccountingForm = ({
  handleSubmit,
  handleChange,
  form,
  editMode,
  closeModal,
  fraccs,
  isAutoCalculating,
  categoryOptions,
  dateError
}) => {
  let buttonLabel;
  if (editMode) {
    buttonLabel = "Guardar Cambios";
  } else if (isAutoCalculating) {
    buttonLabel = "Calcular";
  } else {
    buttonLabel = "Agregar";
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="mb-4">
            <label htmlFor="date" className="block mb-1 font-semibold">{isAutoCalculating ? "Calcular desde (Fecha)" : "Fecha (Dentro del Periodo deseado)"}</label>
            <input
              id="date"
              name="date"
              type="date"
              value={form.date}
              onChange={handleChange}
              required
              className={`w-full px-3 py-2 border rounded ${dateError ? 'border-red-500 bg-red-50' : ''}`}
            />
            {dateError && (
              <div className="text-red-600 text-xs mt-1">La fecha seleccionada está en un periodo cerrado</div>
            )}
          </div>
          {!isAutoCalculating && (
            <div className="mb-4">
              <label htmlFor="amount" className="block mb-1 font-semibold">Monto</label>
              <input id="amount" name="amount" type="number" value={form.amount} onChange={handleChange} required className="w-full px-3 py-2 border rounded" />
            </div>
          )}
          <div className="mb-4">
            <label htmlFor="reference" className="block mb-1 font-semibold">Referencia</label>
            <input id="reference" name="reference" value={form.reference} onChange={handleChange} className="w-full px-3 py-2 border rounded" />
          </div>
          <div className="mb-4">
            <label htmlFor="type" className="block mb-1 font-semibold">Tipo</label>
            <select
              id="type"
              name="type"
              value={isAutoCalculating ? "income" : form.type}
              onChange={handleChange}
              required
              className={`w-full px-3 py-2 border rounded ${isAutoCalculating ? 'bg-gray-100 text-gray-500 cursor-not-allowed' : ''}`}
              disabled={isAutoCalculating}
            >
              <option value="">Selecciona un tipo</option>
              <option value="income">Ingreso</option>
              <option value="outcome">Egreso</option>
            </select>
          </div>
        </div>
        <div>
          <div className="mb-4">
            <label htmlFor="category" className="block mb-1 font-semibold">Categoría</label>
            <select
              id="category"
              name="category"
              value={form.category}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 border border-black rounded"
            >
              <option value="">Selecciona una categoria</option>
              {categoryOptions.map(option => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-6">
            <label htmlFor="neighborhood" className="block mb-1 font-semibold">Coto</label>
            <select
              id="neighborhood"
              name="neighborhood"
              value={form.neighborhood}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 border rounded"
            >
              <option value="">Selecciona un coto</option>
              {fraccs.map(fracc => (
                <option key={fracc} value={fracc}>
                  {fracc}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-4">
            <label htmlFor="description" className="block mb-1 font-semibold">Descripción</label>
            <input id="description" name="description" value={form.description} onChange={handleChange} className="w-full px-3 py-2 border rounded" />
          </div>
        </div>
      </div>
      <div className="flex justify-end gap-2">
        <button type="button" onClick={closeModal} className="ml-2 px-3 py-1 rounded bg-gray-400 hover:bg-gray-600 text-white font-semibold transition">Cancelar</button>
        <button type="submit" className="ml-2 px-3 py-1 rounded bg-primary-500 text-white font-semibold hover:bg-primary-700 transition">{buttonLabel}</button>
      </div>
    </form>
  );
}

AdminAccountingForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  editMode: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  fraccs: PropTypes.array.isRequired,
  isAutoCalculating: PropTypes.bool.isRequired,
  categoryOptions: PropTypes.array.isRequired,
  dateError: PropTypes.bool
};

export default AdminAccountingForm;
